<template>
<div class="container">
    <div class="content">
        <div class="box-card">
            <div class="image-container">
                <img src="../../assets/img/help/sketch1.jpg" class="image" alt="美钥二维码">
                <img src="../../assets/img/help/sketch2.jpg" class="image" alt="美钥二维码">
                <img src="../../assets/img/help/sketch3.jpg" class="image" alt="美钥二维码">
                <img src="../../assets/img/help/sketch4.jpg" class="image" alt="美钥二维码">
            </div>
            <el-collapse>
                <el-collapse-item title="手绘个人二维码上线了！">
                    手绘风格的二维码已经上线！为兼顾用户对个人头像美的追求和隐私保密性需求，我们组织了专业的手绘师团队，为您打造属于自己的动漫卡通风格的美钥码。您可以利用它来制作个人名片，或者送给心爱的TA！如果您有需要，现在您可以移步到淘宝网，搜索<a href="https://item.taobao.com/item.htm?id=561454061147" target="_blank">“个性化定制二维码”</a>来下单！可提供永久解析！
                    <div class="time">2017-02-16</div>
                </el-collapse-item>
            </el-collapse>
        </div>
        <div class="box-card">
            <div class="image-container">
                <img src="../../assets/img/help/bird.jpg" class="image" alt="美钥二维码">
                <img src="../../assets/img/help/kfc1.jpg" class="image" alt="美钥二维码">
                <img src="../../assets/img/help/mcd1.jpg" class="image" alt="美钥二维码">
                <img src="../../assets/img/help/starbucks.jpg" class="image" alt="美钥二维码">
            </div>
            <el-collapse>
                <el-collapse-item title="LOGO二维码来袭！">
                    公司二维码黑乎乎？没有特色不开心？来吧，LOGO二维码，为公司量身打造，产品宣传就靠它了，您可以用它吸引眼球，增强产品价值，让品牌在潜移默化中影响用户！如果您有需要，现在您可以移步到淘宝网，搜索<a href="https://item.taobao.com/item.htm?id=561454061147" target="_blank">“个性化定制二维码”</a>来下单！可提供永久解析！
                    <div class="time">2017-02-16</div>
                    </el-collapse-item>
                </el-collapse>
        </div>
        <div class="box-card">
            <div class="image-container">
                <img src="../../assets/img/help/WeixinLogo.jpg" class="image" alt="微信logo">
            </div>
            <el-collapse>
                <el-collapse-item title="美钥二维码小程序上线啦">
                    还在抱怨在线生成二维码注册登陆太麻烦吗？还在担心二维码生成过程复杂难懂吗？美钥二维码小程序上线啦！只需两步，制作属于你自己的漂亮的二维码！请微信搜索公众号“美钥二维码”或扫描下方二维码体验！
                    <img src="../../assets/img/help/qr.jpg" style="display:block;width:250px;margin:auto;" alt="二维码">
                    <div class="time">2018-04-08</div>
                </el-collapse-item>
            </el-collapse>
        </div>
        <div class="box-card">
            <div class="image-container">
                <img src="../../assets/img/help/shield.jpg" class="image" alt="盾牌">
            </div>
            <el-collapse>
                <el-collapse-item title="安全防护模块上线啦">
                    安全防护模块已经上线，购买了基础版及以上套餐的用户可以免费开启，对您所有的二维码实时保护。
                    <div class="time">2018-04-08</div>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
    <front-footer></front-footer>
</div>
</template>

<script>
import frontFooter from '@c/navigation/frontFooter.vue'
export default {
  components: {
    frontFooter
  },
  mounted () {
    document.title = '美钥二维码 - 帮助'
  }
}
</script>

<style scoped>
.content {
    min-height: 800px;
    display: flex;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
}
.box-card {
    width: 800px;
    padding: 0 20px 0 20px;
    border: #bbbbbb 1px solid;
    background: white;
}
.box-card:hover {
    box-shadow: 5px 5px 10px #bbbbbb;
}
.image-container {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    flex-wrap: wrap;
}
.image {
    width: 130px;
    height: 130px;
}
.time {
    margin-top: 20px;
    color: #bbbbbb;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    flex-wrap: wrap;
}
</style>

